
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[...slug]",
      function () {
        return require("private-next-pages/docs/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/[...slug]"])
      });
    }
  